import type { AsyncNamespaceInput } from "@otto-ec/global-resources/nexus";

/*                    */
export const bannerV1: AsyncNamespaceInput<OttoComponentApi["bannerV1"]> = {
  test<T>(a: T) {
    return `this is test for ${a}`;
  },
};
